<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16.64 16.64"
  >

    <polygon
      points="16.64 10.87 13.45 7.68 13.45 13.46 3.18 13.46 3.18 3.18 8.95 3.18 5.77 0 0 0 0 0 0 0 0 16.64 16.64 16.64 16.64 16.64 16.64 10.87"
      fill="#fff"
    />
    <polygon
      points="16.64 0 10.27 0 12.66 2.39 7.52 7.52 7.52 7.52 7.52 9.11 9.11 9.11 9.11 9.11 14.25 3.98 16.64 6.37 16.64 0"
      fill="#ff7f40"
    />


    <polygon
      points="16.64 10.87 13.45 7.68 13.45 13.46 3.18 13.46 3.18 3.18 8.95 3.18 5.77 0 0 0 0 0 0 0 0 16.64 16.64 16.64 16.64 16.64 16.64 10.87"
      fill="#f47e44"
    />
    <polygon
      points="16.64 0 10.27 0 12.66 2.39 7.52 7.52 7.52 7.52 7.52 9.11 9.11 9.11 9.11 9.11 14.25 3.98 16.64 6.37 16.64 0"
      fill="#ff7f40"
    />

  </svg>
</template>
